// extracted by mini-css-extract-plugin
module.exports = {"fee":"Index_fee__whWDJ","waveTop":"Index_waveTop__6hRwa"};